var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resource-search-tag",on:{"click":_vm.toggleTag}},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('a-glyph',{directives:[{name:"show",rawName:"v-show",value:(_vm.selected),expression:"selected"}],attrs:{"name":"close","size":"xs"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }